import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SysAdminService } from "../../../services/sysadmin.service";
import { ContainersToChangeModel } from "../ContainersToChangeModel";

@Component({
	selector: "app-user-group-add-container",
	templateUrl: "./user-group-add-container.component.html",
	styleUrls: ["./user-group-add-container.component.css"],
})
export class UserGroupAddContainerComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.UserGroupID = this.dialogConfig.data.UserGroupID;
		this.SchoolID = this.dialogConfig.data.SchoolID;

		//Get Data from DB
		this.loadContainerList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	//Data from Parent
	UserGroupID: any;
	SchoolID: any = 0;

	//Table Data
	lstContainers: any = [];
	SelectedContainers: any = [];
	OriginalContainers: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [{ field: "SchoolGroupDesc", header: "School Container" }];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////
	private loadContainerList() {
		this.loading = true;

		var result = this.sysAdminService.UserGroupGetAllContainers(1);
		result.subscribe(
			(response) => {
				this.lstContainers = response;
				this.UpdateSelected();

				this.loading = false;
			},
			(error) => {}
		);
	}

	UpdateSelected() {
		this.SelectedContainers = this.dialogConfig.data.SelectedContainers;
		this.OriginalContainers = this.dialogConfig.data.SelectedContainers;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//Get rid of containers that are already attached to the User Group
		var ContainersToAdd = this.SelectedContainers.filter((cont) => this.OriginalContainers.indexOf(cont) == -1);

		//Create list of strings
		var lstSchoolGroupID: number[] = [];

		for (var i = 0; i < ContainersToAdd.length; i++) {
			var next = Number(ContainersToAdd[i].SchoolGroupID);
			lstSchoolGroupID = [...lstSchoolGroupID, next];
		}

		//Create Query Data
		let data: ContainersToChangeModel = {
			UserGroupID: this.UserGroupID,
			SchoolGroupIDs: lstSchoolGroupID,
		};

		//Call SP
		var result = this.sysAdminService.UserGroupAddContainers(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Containers were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add school containers to the User Group",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////
}
